// extracted by mini-css-extract-plugin
export var orderDetails = "_pp-2";
export var orderImage = "_pp-1";
export var orderMeta = "_pp-3";
export var orderSummary = "_pp-0";
export var rightArrow = "_pp-4";